function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M25.2,3v42.3h-6.3V3H25.2 M28.2,0H15.9v48.3h12.3V0L28.2,0z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M57,11.6v33.7h-6.3V11.6L57,11.6 M60,8.6H47.7v39.7H60V8.6L60,8.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.8,
  y: 18.6,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.8,
  y: 25.3,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.8,
  y: 31.9,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.8,
  y: 38.6,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.8,
  y: 45.2,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 51.9,
  className: "st0",
  width: 60,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 18.6,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 25.3,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 31.9,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 38.6,
  className: "st0",
  width: 12.3,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  y: 45.2,
  className: "st0",
  width: 12.3,
  height: 3
})))));

var SvgGraphs = function SvgGraphs(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 54.9",
    style: {
      enableBackground: "new 0 0 60 54.9"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/graphs.38a71783.svg";
export { SvgGraphs as ReactComponent };